import { collection, getDocs } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { db } from "./Firebase";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Header, Error, Blogs, About, Contact, Calculator } from "./index";
import ReactTab from "./components/ReactTab";
import WebDesignTab from "./components/WebDesignTab";
import LogoTab from "./components/LogoTab";
import IndividualBlog from "./view/IndividualBlog";
import Footer from "./components/Footer";

function App() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getBlogsData() {
    setLoading(true);
    const querySnap = await getDocs(collection(db, "blog"));
    setBlogs(
      querySnap.docs.map((doc) => {
        return {
          id: doc.id,
          data: doc.data(),
        };
      })
    );
    setLoading(false);
  }

  useEffect(() => {
    getBlogsData();
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/about" element={<About />}>
          <Route index element={<ReactTab />} />
          <Route path="react" element={<ReactTab />} />
          <Route path="web" element={<WebDesignTab />} />
          <Route path="logo" element={<LogoTab />} />
          {/* <Route path="video" element={<VideoTab />} /> */}
        </Route>
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/blogs/:blogId" element={<IndividualBlog />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          index
          path="/"
          element={<Blogs blogs={blogs} loading={loading} />}
        />
        <Route path="*" element={<Error />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
